export const menuItems = [
  {
    label: 'About',
    key: 'about',
  },
  {
    label: 'Introduction',
    key: 'cv',
  },
  {
    label: 'Publications',
    key: 'publications',
  },
  {
    label: 'Teaching',
    key: 'teaching',
  },
  {
    label: 'Other',
    key: 'other',
  }
];